/**
 * Loading Spinner Component
 *
 * @package Enterprise\BookingSystem\Components
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

type LoadingSpinnerProps = {
	readonly message?: string;
	readonly size?: 'large' | 'medium' | 'small';
};

export const LoadingSpinner = ({
	message = __('Loading...', 'enterprise-booking-system'),
	size = 'medium',
}: LoadingSpinnerProps) => {
	return (
		<div className={`ebs-loading-spinner ebs-loading-spinner--${size}`}>
			<div className="ebs-loading-spinner__wrapper">
				<span className="ebs-loading-spinner__icon" aria-hidden="true" />
				<span className="screen-reader-text">{message}</span>
			</div>
		</div>
	);
};
